import { PublicContactSearchModal } from './PublicContactSearchModal.component'
import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'

const withUnmountHoc = withUnmountTransition(PublicContactSearchModal)
export { withUnmountHoc as PublicContactSearchModal }
